import { useLocation, useParams } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function DonationPaymentPage() {
  const { state } = useLocation();
  const { id } = useParams();

  const donation = state?.donation;

  if (!donation) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Donation not found. Please start again.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8f6fc]">
      <Navbar />

      <div className="max-w-4xl mx-auto py-16 px-4">

        <div className="bg-white rounded-2xl shadow-lg p-8">

          <h1 className="text-3xl font-bold text-center mb-2">
            Complete Your Donation
          </h1>

          <p className="text-center text-gray-600 mb-8">
            Thank you <strong>{donation.firstName}</strong> ❤️
          </p>

          {/* Amount */}
          <div className="bg-[#6a4bc3]/5 border border-[#6a4bc3]/20 rounded-xl p-6 text-center mb-10">
            <p className="text-gray-500 text-sm">Amount</p>
            <h2 className="text-4xl font-bold text-[#6a4bc3]">
              ₦{Number(donation.amount).toLocaleString()}
            </h2>
          </div>

          {/* Bank Transfer */}
          <div className="border rounded-xl p-6 mb-8">
            <h3 className="font-semibold text-lg mb-4">
              Pay via Bank Transfer
            </h3>

            <div className="space-y-2">
              <p><strong>Bank:</strong> Zenith bank </p>
              <p><strong>Account Name:</strong> Chief Alexander Chukwuma Okoli Foundation</p>
              <p><strong>Account Number:</strong> 1311536356</p>

              <p className="text-sm text-gray-500 mt-4">
                Use this reference:
              </p>

              <div className="bg-gray-100 px-4 py-3 rounded-lg font-mono text-center text-[#6a4bc3]">
                DON-{id}
              </div>
            </div>
          </div>

          {/* Online Payment */}
          {/* <div className="text-center">
            <p className="font-semibold mb-4">
              Or pay instantly online
            </p>

            <button
              onClick={() => window.location.href = `https://paystack.shop/pay/dealdrive`}
              className="bg-[#c9a24d] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#b8923d]"
            >
              Pay Online Now
            </button>
          </div> */}

        </div>

      </div>

      <Footer />
    </div>
  );
}
